import React, { useContext } from 'react';

import { FormContext } from './Form';
import './Form.module.css';

const Message = ({ type }) => {
  const { errorMessage, successMessage } = useContext(FormContext);

  if (errorMessage && type === 'error') {
    return <span styleName="message error">{errorMessage}</span>;
  }

  if (successMessage && type === 'success') {
    return <span styleName="message success">{successMessage}</span>;
  }

  return null;
};

export default Message;
